<app-nav-button *ngFor="let button of navItems$ | async; let i = index" [data]="button" [showDivider]="i !== 0"></app-nav-button>
